import { useState } from "react";

import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

export default function CustomArea({ selectedOption }) {
  // Define which fields should be shown for each option
  const MsgOpt = [
    'inspection_message_one_time',
    'before_services_message',
    'after_services_message',
    'after_3rd_week_of_service',
    'inspection_message_for_first_time',
    'after_services_message_plan'
  ];

  const fieldConfigs = [
    // 0: Inspection Message
    ["msg-name", "msg-date", "msg-start", "msg-end"],
    // 1: Before Services Message
    ["msg-name", "msg-date", "msg-start", "msg-end"],
    // 2: After Services Message
    ["msg-name", "msg-treatment", "msg-date"],
    // 3: After 3rd Week of Services
    ["msg-name"],
    // 4: Inspection message (For First Time)
    ["msg-name", "msg-company", "msg-date", "msg-start", "msg-end"],
    // 5: After Services Message2
    ["msg-name", "msg-company", "msg-date", "msg-start", "msg-end", "msg-operator"],
  ];

  const fieldLabels = {
    "msg-name": "Customer Name",
    "msg-company": "Company Name Team",
    "msg-treatment": "Treatment",
    "msg-date": "Date",
    "msg-start": "Start Time",
    "msg-end": "End Time",
    "msg-operator": "Operator Name",
  };

  const fieldTypes = {
    "msg-name": "text",
    "msg-company": "text",
    "msg-treatment": "text",
    "msg-date": "date",
    "msg-start": "time",
    "msg-end": "time",
    "msg-operator": "text",
  };

  const fieldsToShow = fieldConfigs[selectedOption]

  const [phoneNum, setPhoneNum] = useState([""]);
  const [showAllPhone, setShowAllPhone] = useState(false);
  const [formValues, setFormValues] = useState({});

  const addPhoneNumber = () => {
    setPhoneNum([...phoneNum, ""]);
  };

  const removePhoneNumber = (index) => {
    if (phoneNum.length > 1) {
      setPhoneNum(phoneNum.filter((_, i) => i !== index));
    }
  };

  const updatePhoneNumber = (index, value) => {
    const updated = [...phoneNum];
    updated[index] = value;

    setPhoneNum(updated);
  };

  const handleInputChange = (field, value) => {
    setFormValues((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = () => {
    for (let phone of phoneNum) {
      if (Common.isEmpty(phone)) {
        Common.errorMsg('전화번호를 확인해 주세요.');

        return true;
      }
    }
    
    for (let field of fieldsToShow) {
      if (Common.isEmpty(formValues[field])) {
        Common.errorMsg('데이터를 확인해 주세요.');

        return true;
      }
    }

    const message = {
      messaging_product: "whatsapp",
      to: "%s",
      type: "template",
      template: {
        name: MsgOpt[selectedOption],
        language: {
          code: "en"
        },
        components: [
          {
            type: "body",
            parameters: fieldsToShow.map((field) => ({
              type: "text",
              text: formValues[field] || ""
            }))
          }
        ]
      }
    };

    Server.sendPost('client/whatsApp', {
      phoneNumber: phoneNum,
      jsonBody: message
    }, whatsAppSendCallback).then();
  };

  const whatsAppSendCallback = res => {
    Common.errorMsg('발송되었습니다.');
    
    const initialValues = {};
    
    fieldsToShow.forEach((field) => {
      initialValues[field] = "";
    });
    
    setFormValues(initialValues);
    setPhoneNum([""]); // 전화번호도 초기화
  };

  const maxVisiblePhones = 5;
  const visiblePhones = showAllPhone ? phoneNum : phoneNum.slice(0, maxVisiblePhones);
  const hasMorePhones = phoneNum.length > maxVisiblePhones;

  return (
    <div className="custom-area">
      <div className="phone-section">
        <div className="phone-header">
          <label>Phone Numbers (International phone number format)</label>
          <button type="button" className="add-btn" onClick={addPhoneNumber}>
            Add Phone
          </button>
        </div>

        <div className="phone-list">
          {visiblePhones.map((phone, index) => (
            <div key={index} className="phone-input-group">
              <input
                type="tel"
                value={phone}
                onChange={(e) => updatePhoneNumber(index, e.target.value)}
                placeholder="Please write down the Phone Number"
                className="phone-input"
              />
              {phoneNum.length > 1 && (
                <button type="button" onClick={() => removePhoneNumber(index)} className="remove-phone-btn">
                  ×
                </button>
              )}
            </div>
          ))}

          {hasMorePhones && (
            <button type="button" onClick={() => setShowAllPhone(!showAllPhone)} className="toggle-phones-btn">
              {showAllPhone
                ? `Show Less (${phoneNum.length - maxVisiblePhones} hidden)`
                : `Show All (${phoneNum.length - maxVisiblePhones} more)`}
            </button>
          )}
        </div>
      </div>
      <div className="input-section">
        {fieldsToShow.map((fieldName, index) => (
          <div key={fieldName} className="input-in">
            <label htmlFor={fieldName}>{fieldLabels[fieldName]}</label>
            <input
              type={fieldTypes[fieldName]}
              name={fieldName}
              id={fieldName}
              value={formValues[fieldName] || ""}
              onChange={(e) => handleInputChange(fieldName, e.target.value)}
            />
          </div>
        ))}

      </div>
      <button className="send-btn" onClick={handleSubmit}>Send</button>
    </div>
  );
}